import type {
  BaseReferenceField,
  Field,
  PatternsFieldType,
} from '../types/Field';

export type ReferenceFieldType = Extract<
  PatternsFieldType,
  'REFERENCE' | 'MULTI_REFERENCE'
>;

export const isReferenceFieldType = (
  type: string | undefined,
): type is ReferenceFieldType =>
  type === 'REFERENCE' || type === 'MULTI_REFERENCE';

export const isReferenceField = (
  field: Field | undefined,
): field is BaseReferenceField & { type: ReferenceFieldType } =>
  Boolean(field && isReferenceFieldType(field.type));
